import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_V2 = `${BACKEND_URL}/api/v2`;

export const BetaPuls = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API_V2}/admin/pulse`, { withCredentials: true }).then((res) => setData(res.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const maxVal = Math.max(1, ...data.days.map((d) => d.registrations + d.carma + d.impulses));

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 space-y-4 mt-6" data-testid="beta-puls">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold">Puls (letzte 14 Tage)</h3>
        <div className="flex gap-4 text-xs text-gray-500">
          <span data-testid="pulse-total">{data.totalUsers} User gesamt</span>
          <span data-testid="pulse-regs-today" className="text-green-600 font-medium">+{data.registrationsToday} heute</span>
          <span data-testid="pulse-active-today">{data.activeToday} aktiv heute</span>
          <span data-testid="pulse-active-7d">{data.active7d} aktiv (7 Tage)</span>
        </div>
      </div>
      <div className="flex items-end gap-1 h-28">
        {data.days.map((d) => {
          const total = d.registrations + d.carma + d.impulses;
          const h = Math.max(4, Math.round((total / maxVal) * 100));
          return (
            <div key={d.date} className="flex-1 flex flex-col items-center gap-1 group relative" data-testid={`pulse-day-${d.date}`}>
              <div className="absolute -top-14 hidden group-hover:block bg-gray-800 text-white text-[10px] rounded px-2 py-1 whitespace-nowrap z-10">
                {d.date}: {d.registrations} Reg. · {d.carma} Carma · {d.impulses} Impulse
              </div>
              <div className="w-full flex flex-col justify-end" style={{ height: '90px' }}>
                <div className="w-full rounded-t-sm bg-blue-500/80" style={{ height: `${h}%` }} />
              </div>
              <span className="text-[8px] text-gray-400">{d.date.slice(8)}</span>
            </div>
          );
        })}
      </div>
      <p className="text-[10px] text-gray-400">Balken = Registrierungen + Carma + Impulse pro Tag. Hover für Details.</p>
    </div>
  );
};
